import { LeverageFilter } from '@arrived/models';

export const leverageFilterOptions = [
  { filter: null, label: { id: 'all', defaultMessage: 'All' } },
  {
    filter: LeverageFilter.NONE,
    label: {
      id: 'none',
      defaultMessage: 'None',
    },
  },
  {
    filter: LeverageFilter.LOW,
    label: {
      id: 'low',
      defaultMessage: 'Low',
    },
  },
  {
    filter: LeverageFilter.MEDIUM,
    label: {
      id: 'medium',
      defaultMessage: 'Medium',
    },
  },
  {
    filter: LeverageFilter.HIGH,
    label: {
      id: 'high',
      defaultMessage: 'High',
    },
  },
];
